<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="titlePage" id="tp01">
<a id="page01"></a>
<a id="page02"></a>
<a id="page03"></a>
<h2 class="titlePageTitle">Ghost Radio</h2>
<h2 class="titlePageAuthor">Leopoldo Gout</h2>
<p class="titlePageText">Illustrations by the Fates Crew and Leopoldo Gout</p>
<p class="titlePageLogo"><img alt="image" src="images/logo.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?ea5c9232